import { useTheme } from "@/context/ThemeContext";

/** Propojo mark. Swaps automatically with the active theme; artwork is never altered. */
export const Logo = ({ size = 32, withWordmark = false, className = "", testid = "propojo-logo" }) => {
  const { resolved } = useTheme();
  const src = resolved === "light" ? "/propojo-logo-light.png" : "/propojo-logo-dark.png";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid={testid}>
      <img
        src={src}
        alt="Propojo"
        width={size}
        height={size}
        style={{ height: size, width: "auto" }}
        className="block select-none"
        draggable={false}
      />
      {withWordmark && <span className="font-display font-extrabold tracking-tight">Propojo</span>}
    </span>
  );
};

export default Logo;
